export const PartnerDeclineReasons = {
  Swamped: `I'm swamped right now, ask me later.`,
  Schedule: `The specified days/times don't fit my schedule.`,
  Time: `The time needed to complete is more than I can give right now.`,
  Skills: `I don't have the needed skills or experience for this event.`,
  Distance: `This is too far away from my home/work.`,
  Interest: `I'm not interested in volunteering my time in this way.`
};

// starts with...
export const StewardDeclineReasons = {
  Email: `Email address for this partner no longer exists`,
  Delay: `Partner has not responded to invitation`,
  Available: 'Partner is not available for your event at this time'
};

export const partnerResponses = [
  PartnerDeclineReasons.Swamped,
  PartnerDeclineReasons.Schedule,
  PartnerDeclineReasons.Time,
  PartnerDeclineReasons.Skills,
  PartnerDeclineReasons.Distance,
  PartnerDeclineReasons.Interest,
  // StewardDeclineReasons.Email,
  // StewardDeclineReasons.Delay,
  // StewardDeclineReasons.Available,
];

export const stewardResponses = [
  // PartnerDeclineReasons.Swamped,
  // PartnerDeclineReasons.Schedule,
  // PartnerDeclineReasons.Time,
  // PartnerDeclineReasons.Skills,
  // PartnerDeclineReasons.Distance,
  // PartnerDeclineReasons.Interest,
  StewardDeclineReasons.Email,
  StewardDeclineReasons.Delay,
  StewardDeclineReasons.Available,
];
